module.exports = __webpack_public_path__ + "img/black-week-super-desconto.4eec22bb.webp";